import axiosModule, { AxiosInstance } from 'axios';
import {
  IMicrosoftAuthResponseData,
  IMicrosoftAuthService
} from './microsoft-auth.types';

export class MicrosoftAuthService implements IMicrosoftAuthService {
  private endpoint = 'v1/auth/microsoft/';
  private unauthenticatedAxios: AxiosInstance;

  constructor(private axios: AxiosInstance) {
    // Use a dedicated client for the OAuth code exchange so we do not inherit
    // any JWT defaults or auth-related interceptors from the app client.
    this.unauthenticatedAxios = axiosModule.create({
      baseURL: this.axios.defaults.baseURL,
      timeout: this.axios.defaults.timeout,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  authorize(
    code: string,
    redirect_uri: string
  ): Promise<IMicrosoftAuthResponseData> {
    return this.unauthenticatedAxios
      .post<IMicrosoftAuthResponseData>(this.endpoint, { code, redirect_uri })
      .then(({ data }) => data);
  }
}
